import React from 'react';

import cn from 'classnames';

import { ICategory } from '@entities/AdminConversationCategory/model/types';
import { AdminConversationForm } from '@entities/AdminConversationCategory/ui/AdminConversationForm';
import { AdminConversationCategoryUpsertModal } from '@features/AdminConversationCategoryUpsertModal';
import { ConversationClientModal } from '@features/ConversationClientModal';
import { Editable, Flex, Icon, UiButton, UiText } from '@shared/ui';

import cls from './AdminConversationCategory.module.css';
import { useAdminConversationCategory } from '../lib/hooks/useAdminConversationCategory';

interface AdminConversationCategoryProps {
    category: ICategory;
    isLast?: boolean;
    isFirst?: boolean;
}

export const AdminConversationCategory = ({
    category,
    isFirst,
    isLast,
}: AdminConversationCategoryProps) => {
    const {
        handleToggle,
        onTitleChange,
        onSortChange,
        onDeleteCategory,
        isShowForms,
        maxHeight,
        contentRef,
        openCategoryUpsertModal,
        isOpenCategoryUpsertModal,
        onCloseModal,
        formId,
        onEditForm,
        prevData,
        onShowPrev,
        onHidePrev,
    } = useAdminConversationCategory(category);

    return (
        <>
            <div className={cls.AdminConversationCategory}>
                <Flex direction="row" gap={24}>
                    <h1
                        className={cn(cls.categoryTitle, isShowForms && cls.showArrow)}
                        onClick={handleToggle}
                    >
                        <div onClick={(e) => e.stopPropagation()} className={cls.categoryTitle}>
                            <Editable onSubmit={onTitleChange} value={category.title}>
                                <UiText variant="heading" className={cls.categoryTitle}>
                                    {category.title}
                                </UiText>
                            </Editable>
                        </div>

                        <Icon iconName="selectArrowThin" />
                    </h1>

                    <UiButton
                        onClick={openCategoryUpsertModal}
                        btnText="Добавить форму"
                        startIcon={<Icon iconName="plus" />}
                    />
                    <Flex gap={8} className={cls.headerInterface}>
                        <UiButton
                            disabled={isLast}
                            onClick={() => onSortChange('down')}
                            variant="icon"
                            startIcon={<Icon iconName="arrowDown" />}
                            className={cls.headerInterfaceButton}
                        />
                        <UiButton
                            disabled={isFirst}
                            onClick={() => onSortChange('up')}
                            variant="icon"
                            startIcon={<Icon iconName="arrowUp" />}
                            className={cls.headerInterfaceButton}
                        />
                        <UiButton
                            onClick={onDeleteCategory}
                            variant="icon"
                            startIcon={<Icon iconName="filesDelete" />}
                            className={cls.headerInterfaceButton}
                        />
                    </Flex>
                </Flex>
                <div
                    style={{
                        maxHeight: isShowForms ? `${maxHeight}px` : 0,
                        opacity: isShowForms ? 1 : 0,
                    }}
                    ref={contentRef}
                    className={cls.formListWrapper}
                >
                    <Flex direction="column" gap={12} className={cls.formList}>
                        {category.items.map((formItem, index) => (
                            <AdminConversationForm
                                onShowPrev={onShowPrev}
                                onEditForm={onEditForm}
                                form={formItem}
                                key={formItem.id}
                                isFirst={index === 0}
                                isLast={index === category.items.length - 1}
                            />
                        ))}
                    </Flex>
                </div>
            </div>
            {prevData && (
                <ConversationClientModal
                    prevData={prevData}
                    close={onHidePrev}
                    onSendSurvey={() => {}}
                />
            )}
            {isOpenCategoryUpsertModal && (
                <AdminConversationCategoryUpsertModal
                    formId={formId}
                    categoryId={category.id}
                    isOpen={isOpenCategoryUpsertModal}
                    onClose={onCloseModal}
                />
            )}
        </>
    );
};
